import React from "react";
import MaterialTable from "material-table";
import PropTypes from "prop-types";
import useTableAmortization from "hooks/useTableAmortization";
import useAmortizationTableStyles from "styles/useAmortizationTableStyles";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
const AmortizationTable = ({
  loanAmount,
  interestRate,
  loanTerm,
  creditDownPayment,
  paymentDay
}) => {
  const classes = useAmortizationTableStyles();
  const { calculatePayments, data } = useTableAmortization({
    loanAmount,
    interestRate,
    loanTerm,
    creditDownPayment,
    paymentDay
  });
  return (
    <MaterialTable
      className={classes.table}
      title="Tabla de amortizaciones"
      columns={[
        {
          title: "No.",
          field: "id",
          type: "numeric",
          headerStyle: { textAlign: "center", width: "10%" },
          cellStyle: { textAlign: "center" }
        },
        {
          title: "Pago sin intereses",
          field: "montoapagar",
          type: "currency",
          currencySetting: { locale: "es-MX", currencyCode: "MXN", minimumFractionDigits: 2 },
          headerStyle: { textAlign: "center", width: "40%" },
          cellStyle: { textAlign: "center" }
        },
        {
          title: "Fecha proximo pago",
          field: "fechaapagar",
          type: "string",
          headerStyle: { textAlign: "center", width: "40%" },
          cellStyle: { textAlign: "center" }
        }
      ]}
      data={data}
      options={{
        search: false,
        paging: false,
        headerStyle: { fontWeight: "bold", backgroundColor: "#fafafa" }
      }}
      actions={[
        {
          icon: AttachMoneyIcon,
          tooltip: "Calcular tabla de amortizacion",
          isFreeAction: true,
          onClick: () => calculatePayments()
        }
      ]}
    />
  );
};
AmortizationTable.propTypes = {
  loanAmount: PropTypes.number,
  interestRate: PropTypes.number,
  loanTerm: PropTypes.number,
  creditDownPayment: PropTypes.string,
  paymentDay: PropTypes.string
};
export default AmortizationTable;
